import timg1 from '../images/team/1.jpg'
import timg2 from '../images/team/2.jpg'
import timg3 from '../images/team/3.jpg'
import timg4 from '../images/team/4.jpg'
import timg5 from '../images/team/5.jpg'
import timg6 from '../images/team/6.jpg'
import timg7 from '../images/team/7.jpg'
import timg8 from '../images/team/8.jpg'
import timg9 from '../images/team/9.jpg'
import timg10 from '../images/team/10.jpg'

import asim from '../images/team/asim.png'
import hikmet from '../images/team/hikmet.png'
import recep from '../images/team/recep.png'
import taha from '../images/team/taha.png'
import nurettin from '../images/team/nurettin.png'
import burhan from '../images/team/burhan.png'


const Teams = [
    {
       id:'1',
       tImg:recep,
       name:'Recep Dinc',
       title:'Lehigh Valley Coordinator',     
    },
    {
       id:'2',
       tImg:nurettin,
       name:'Nurettin Celiksu',
       title:'South Jersey Coordinator',     
    },
    {
       id:'3',
       tImg:asim,
       name:'Asim Ongul',
       title:'Philadelphia Coordinator',     
    },
    {
       id:'4',
       tImg:hikmet,
       name:'Hikmet Eroglu',
       title:'Senior Coordinator',     
    },
    {
       id:'5',
       tImg:burhan,
       name:'Burhan Gokalp',
       title:'University Coordinator',     
    },
    {
       id:'6',
       tImg:taha,
       name:'Taha Ormanci',
       title:'Volunteer',     
    },
    {
       id:'7',
       tImg:timg7,
       name:'Maria Belziana',
       title:'Volunteer',     
    },
    {
       id:'8',
       tImg:timg8,
       name:'Robert Chirls',
       title:'Volunteer',     
    },
    {
       id:'9',
       tImg:timg9,
       name:'William Frost',
       title:'CEO',     
    },
    {
       id:'10',
       tImg:timg10,
       name:'Zenefer Marry',
       title:'Manager',     
    }
    
]

export default Teams;